// extracted by mini-css-extract-plugin
export var bodyTable = "pricingComparison-module--bodyTable--6e0e2";
export var desktopColOnly = "pricingComparison-module--desktop-col-only--4f09b";
export var featureColInner = "pricingComparison-module--featureColInner--9664b";
export var featureColInnerTrialMobile = "pricingComparison-module--featureColInnerTrialMobile--92ea7";
export var featureColSublabel = "pricingComparison-module--featureColSublabel--dc1c9";
export var featureColSublabelMobile = "pricingComparison-module--featureColSublabelMobile--a59c5";
export var firstCol = "pricingComparison-module--firstCol--7fb9b";
export var firstColInner = "pricingComparison-module--firstColInner--eb2b7";
export var firstColLabel = "pricingComparison-module--firstColLabel--a0189";
export var firstColLabelDesktop = "pricingComparison-module--firstColLabelDesktop--1e794";
export var firstColLabelMobile = "pricingComparison-module--firstColLabelMobile--fcdef";
export var firstColSublabel = "pricingComparison-module--firstColSublabel--275d3";
export var fullWidth = "pricingComparison-module--full-width--5c2c6";
export var headerRow = "pricingComparison-module--headerRow--856ef";
export var iconCheckmark = "pricingComparison-module--iconCheckmark--e9c05";
export var lastSectionTr = "pricingComparison-module--lastSectionTr--f85d6";
export var leftBoxShadow = "pricingComparison-module--leftBoxShadow--3f9d1";
export var mobileColOnly = "pricingComparison-module--mobile-col-only--86423";
export var monthlyPriceLabel = "pricingComparison-module--monthlyPriceLabel--23e1d";
export var planCol = "pricingComparison-module--planCol--8e7de";
export var planColExtraInfo = "pricingComparison-module--planColExtraInfo--3d29b";
export var planColExtraInfoMobile = "pricingComparison-module--planColExtraInfoMobile--cd48f";
export var planColFullWidth = "pricingComparison-module--planColFullWidth--bcf76";
export var planColLabel = "pricingComparison-module--planColLabel--c9690";
export var planColLabelMobile = "pricingComparison-module--planColLabelMobile--4d947";
export var planHeaderCol = "pricingComparison-module--planHeaderCol--d0e66";
export var planHeaderColInner = "pricingComparison-module--planHeaderColInner--6b16a";
export var planHeaderColWrapper = "pricingComparison-module--planHeaderColWrapper--783aa";
export var planWho = "pricingComparison-module--planWho--f23a4";
export var priceColInner = "pricingComparison-module--priceColInner--3434a";
export var pricePeriod = "pricingComparison-module--pricePeriod--6febd";
export var sectionHeaderRow = "pricingComparison-module--sectionHeaderRow--8d115";
export var subline = "pricingComparison-module--subline--1c226";
export var table = "pricingComparison-module--table--08eb2";
export var tableCtn = "pricingComparison-module--tableCtn--c13e1";
export var tableCtnInner = "pricingComparison-module--tableCtnInner--d5cf0";
export var top = "pricingComparison-module--top--af117";
export var trialButton = "pricingComparison-module--trial-button--b7f1f";